// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"e4485896","50":"5ebe4140","281":"e5f450d8","716":"ee23d9f3"}[chunkId] + ".css";
};